module.exports = __webpack_public_path__ + "static/img/h-i-1.e2955ccd.png";